import React from "react"
import { graphql, useStaticQuery } from "gatsby"
export interface VisualCortexBlockProps {}
const video = require("../../images/video/vcx-video.mp4") as string
const VisualCortexBlock: React.SFC<VisualCortexBlockProps> = () => {
  const query = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "header_banner/eye.jpg" }) {
        relativePath
        base
        childImageSharp {
          fluid(maxHeight: 150, maxWidth: 240, jpegQuality: 70) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <div className="container-full block-visualCortex">
        <div className="row no-gutters row-banner-hero">
          <div className="backdrop-bg"></div>
          <div className="col-lg-6 block-visualCortex__header">
            <h3 className="u-text-center u-font-family-roboto">VisualCortex</h3>
            <span>Realtime Image-Recognition AI</span>
          </div>
          <video
            className="video-player"
            height="100%"
            width="100%"
            loop
            muted
            autoPlay
          >
            <source src={video} type="video/mp4" />
          </video>
        </div>
      </div>
      <div className="container">
        <p className="text-hero">
          “VisualCortex” is the application responsible for the visual
          capabilities of Human-like AI platform “LUDENS”. Spatial information
          is mapped out like human vision to include movement, posture, facial
          expression, gaze, line of sight, and more. These characteristics are
          analyzed in real-time from the aggregated area.
        </p>
      </div>
    </>
  )
}

export default VisualCortexBlock
